/* This file is autogenerated, see readme.md for instructions */
import CsvSvgIcon from '@bloomreach/banana-theme/icons/csv.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CsvIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CsvSvgIcon />
    </Icon>
  );
});

CsvIcon.displayName = 'CsvIcon';

export default CsvIcon;
